module.exports = __webpack_public_path__ + "static/media/explorar-uerre.78211e05.jpg";